import { render, staticRenderFns } from "./List-Branch-Wallets.vue?vue&type=template&id=42c418eb&scoped=true"
import script from "./List-Branch-Wallets.vue?vue&type=script&lang=js"
export * from "./List-Branch-Wallets.vue?vue&type=script&lang=js"
import style0 from "./List-Branch-Wallets.vue?vue&type=style&index=0&id=42c418eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c418eb",
  null
  
)

export default component.exports